import { languageConfigList } from '@configs/layout';
import detectBrowserLanguage from 'detect-browser-language';
import { country_LangCode } from '@models/commonModel';
/**
 * @description 브라우저 언어 설정 값 리턴 (만약 제공되는 언어 3가지 이외인 경우 한국어 우선순위)
 */
export const detectLanguage = () => {
  if (typeof window !== 'undefined') {
    if (!localStorage.getItem('locale')) {
      if (languageConfigList.filter((x) => x.Code === detectBrowserLanguage()).length < 1) {
        return languageConfigList.find((x) => x.LanguageName === 'KOR').Code;
      } else {
        return detectBrowserLanguage();
      }
    } else {
      return localStorage.getItem('locale');
    }
  } else {
    return 'en';
  }
};

// getLanguageCode 가 있어 쓰일것 같진 않아 보인다.
export const getLocaleValue = () => {
  if (typeof window !== 'undefined') {
    let nowlocale: string | undefined = localStorage.getItem('locale');

    if (!nowlocale) {
      nowlocale = detectLanguage();
      localStorage.setItem('locale', nowlocale);
    }

    return nowlocale;
  } else {
    return 'en';
  }
};

export const setLocaleValue = (nowlocale) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('locale', nowlocale);
  }
};

export const getLocaleValueForFlag = () => {
  if (typeof window !== 'undefined') {
    let nowlocale: string | undefined = localStorage.getItem('locale');

    if (!nowlocale) {
      nowlocale = detectLanguage();
    }
    switch (nowlocale) {
      case 'jp':
        return 'JP';
      case 'ko':
        return 'KR';
      default:
        return 'US';
    }
  } else {
    return 'US';
  }
};

/**
 * @description 국가언어 매칭 함수
 * @param countryCode 2글자 국가코드(대문자)
 * @returns 소문자 영어 2글자
 */
export const getLanguageCode = (countryCode: string) => {
  const objIndex = country_LangCode.findIndex((obj) => obj.code === countryCode);
  if (objIndex !== -1) {
    return country_LangCode[objIndex].langCode;
  } else {
    return 'en';
  }
};
